import { render, staticRenderFns } from "./item-dropdown.vue?vue&type=template&id=5799d6a3&"
import script from "./item-dropdown.vue?vue&type=script&lang=js&"
export * from "./item-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports